import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import InstallGuide from './InstallGuide'
import { post } from './util'
import Button from './components/Button'
import logo from './logo.png'

const isWeiXin = () => window.navigator.userAgent.toLowerCase().includes('micromessenger')

const Install = () => {
  const [companyID, setCompanyID] = useState('')
  const [userID, setUserID] = useState('')
  const [passcode, setPasscode] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    setLoading(true)
    post('portal/install-user-login', { companyID, userID, passcode })
      .then(ret => {
        setLoading(false)

        if (ret.error || !ret.success) {
          alert(ret.error)
          return
        }

        setSuccess(true)
      })
      .catch(e => {
        setLoading(false)
        alert(e.message)
      })
  }

  if (isWeiXin()) {
    return (
      <div className='max-w-lg mx-auto mt-10 rounded-3xl border border-slate-200 bg-white shadow-soft p-8 text-center text-slate-700'>
        请点击右上角按钮，选择“在默认浏览器中打开”。
      </div>
    )
  }

  if (success) {
    return (
      <div className='text-view pt-running-text'>
        <ul className='pt-breadcrumbs'>
          <li><Link className='pt-breadcrumb' to='/'>Home</Link></li>
          <li><span className='pt-breadcrumb pt-breadcrumb-current'>Surge Enterprise Install Guide</span></li>
        </ul>
        <InstallGuide />
      </div>
    )
  }

  return (
    <div className='min-h-screen bg-surface flex items-center justify-center px-4'>
      <div className='w-full max-w-md rounded-[32px] border border-slate-200 shadow-soft bg-white p-8 space-y-6'>
        <div className='flex items-center justify-between'>
          <div>
            <p className='text-2xl font-semibold text-ink'>Surge Enterprise</p>
            <p className='text-sm text-slate-500'>Authorized users only. Enter your enterprise credential.</p>
          </div>
          <img src={logo} alt='Logo' width='48' height='48' />
        </div>
        <form className='space-y-4' onSubmit={handleSubmit}>
          <div>
            <label className='text-sm font-medium text-slate-600'>Company ID</label>
            <input
              value={companyID}
              onChange={e => setCompanyID(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <div>
            <label className='text-sm font-medium text-slate-600'>User ID</label>
            <input
              value={userID}
              onChange={e => setUserID(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <div>
            <label className='text-sm font-medium text-slate-600'>Passcode</label>
            <input
              type='password'
              value={passcode}
              onChange={e => setPasscode(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <Button type='submit' className='w-full justify-center' disabled={loading}>
            {loading ? 'Checking…' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default Install
